module.exports = __webpack_public_path__ + "img/orbs.6792a31a.png";